/* =================================================================
   2. Provider registry — with API-key acquisition links
   ================================================================= */
export const PROVIDERS = {
  openai: {
    label: "OpenAI",
    colorClass: "openai",
    keyName: "lp_aiboard_key_openai",
    keyPlaceholder: "sk-...",
    keyUrl: "https://platform.openai.com/api-keys",
    keyHelp: { en: "Generate at platform.openai.com → API keys.",
               es: "Genera en platform.openai.com → API keys.",
               pt: "Gere em platform.openai.com → API keys." }
  },
  anthropic: {
    label: "Anthropic",
    colorClass: "anthropic",
    keyName: "lp_aiboard_key_anthropic",
    keyPlaceholder: "sk-ant-...",
    keyUrl: "https://console.anthropic.com/settings/keys",
    keyHelp: { en: "Generate at console.anthropic.com → Settings → API Keys.",
               es: "Genera en console.anthropic.com → Settings → API Keys.",
               pt: "Gere em console.anthropic.com → Settings → API Keys." }
  },
  google: {
    label: "Google · Gemini",
    colorClass: "google",
    keyName: "lp_aiboard_key_google",
    keyPlaceholder: "AIza...",
    keyUrl: "https://aistudio.google.com/app/apikey",
    keyHelp: { en: "Generate at Google AI Studio → Get API key.",
               es: "Genera en Google AI Studio → Get API key.",
               pt: "Gere no Google AI Studio → Get API key." }
  },
  xai: {
    label: "xAI · Grok",
    colorClass: "xai",
    keyName: "lp_aiboard_key_xai",
    keyPlaceholder: "xai-...",
    keyUrl: "https://console.x.ai/",
    keyHelp: { en: "Generate at console.x.ai → API Keys.",
               es: "Genera en console.x.ai → API Keys.",
               pt: "Gere em console.x.ai → API Keys." }
  },
  mistral: {
    label: "Mistral",
    colorClass: "mistral",
    keyName: "lp_aiboard_key_mistral",
    keyPlaceholder: "...",
    keyUrl: "https://console.mistral.ai/api-keys/",
    keyHelp: { en: "Generate at console.mistral.ai → API Keys.",
               es: "Genera en console.mistral.ai → API Keys.",
               pt: "Gere em console.mistral.ai → API Keys." }
  },
  groq: {
    label: "Groq",
    colorClass: "groq",
    keyName: "lp_aiboard_key_groq",
    keyPlaceholder: "gsk_...",
    keyUrl: "https://console.groq.com/keys",
    keyHelp: { en: "Free tier — ultra-fast inference. Generate at console.groq.com → API Keys.",
               es: "Tier gratuito — inferencia ultra-rápida. Genera en console.groq.com → API Keys.",
               pt: "Camada grátis — inferência ultra-rápida. Gere em console.groq.com → API Keys." }
  },
  openrouter: {
    label: "OpenRouter",
    colorClass: "openrouter",
    keyName: "lp_aiboard_key_openrouter",
    keyPlaceholder: "sk-or-...",
    keyUrl: "https://openrouter.ai/keys",
    keyHelp: { en: "Aggregator with several free models. Generate at openrouter.ai/keys.",
               es: "Agregador con varios modelos gratis. Genera en openrouter.ai/keys.",
               pt: "Agregador com vários modelos grátis. Gere em openrouter.ai/keys." }
  },
  deepseek: {
    label: "DeepSeek",
    colorClass: "deepseek",
    keyName: "lp_aiboard_key_deepseek",
    keyPlaceholder: "sk-...",
    keyUrl: "https://platform.deepseek.com/api_keys",
    keyHelp: { en: "Frontier quality at ~10× lower price. Generate at platform.deepseek.com.",
               es: "Calidad frontier a ~10× menor precio. Genera en platform.deepseek.com.",
               pt: "Qualidade frontier por ~10× menor preço. Gere em platform.deepseek.com." }
  },
};
